import { noop } from 'lodash'
import type { Logger, LoggerAdapter } from './types'

export const createLogger = (): Logger => {
  const handlers = new Set<LoggerAdapter>()
  const callHandlers =
    (namespace: keyof LoggerAdapter) =>
    (...args: Parameters<Required<LoggerAdapter>[keyof LoggerAdapter]>) => {
      handlers.forEach(handler => (handler[namespace] || noop)(...args))
    }

  return {
    error: (error, extra) => callHandlers('error')(error, extra),
    breadcrumb: ({ message, category, data }) =>
      callHandlers('breadcrumb')({ message, category, data }),

    bi: event => callHandlers('bi')(event),

    updateContext: updates => callHandlers('updateContext')(updates),

    registerHandler: handler => {
      handlers.add(handler)
      return () => {
        handlers.delete(handler)
      }
    },
  }
}
